import styled from 'styled-components';
import theme from 'src/styles/theme';
import { device } from 'src/styles/global';

export interface Props {
  color: string;
  backgroundColor: string;
}

export interface mobileTitleButtonProps {
  isMobileSortActive: boolean;
}

export const SongTitleStyle = styled.div`
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    font-weight: 700;
  }
`;

export const ArtistNameStyle = styled.div`
  font-size: 14px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
`;

export const MetricWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  cursor: pointer;
`;

export const InsightsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const StatusWrapper = styled.div`
  cursor: pointer;
`;

export const TotalSpinsStyle = styled.div`
  font-size: 14px;
  color: ${theme.colors.neutralW40};
`;

export const ComparisonBadgeStyle = styled.div<Props>`
  display: flex;
  align-self: flex-start;
  font-size: 12px;
  font-weight: 600;
  border-radius: 5px;
  padding: 1px 6px;
  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const StatusStyle = styled.div`
  font-size: 14px;
  color: ${theme.colors.neutralW40};
`;

export const ExtendRenewStyle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${theme.colors.mtr60};

  &:hover {
    text-decoration: underline;
    font-weight: 700;
  }
`;

export const HeaderStyleMobile = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  white-space: nowrap;
`;

export const HeaderButtonMobile = styled.button<mobileTitleButtonProps>`
  border: none;
  background: none;
  padding: 0px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;

  color: ${({ isMobileSortActive }) =>
    isMobileSortActive ? theme.colors.neutralW20 : theme.colors.neutralW70};
`;

export const HeaderSeparatorMobile = styled.span`
  color: ${theme.colors.neutralW70};
`;

export const ClickableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

export const SongTitleStyleMobile = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${theme.colors.neutralW40};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ArtistStyleMobile = styled.div`
  font-size: 12px;
  color: ${theme.colors.neutralW50};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SomethingWrongWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  color: ${theme.colors.neutralW10};
  padding: 0px 32px 24px;
  gap: 4px;

  @media ${device.mobile} {
    padding: 0px 24px 16px;
    gap: 0px;
  }
`;

export const ContactLink = styled.a`
  text-decoration: underline;
  color: ${theme.colors.mtr60};
  cursor: pointer;
`;

export const NoResultFoundWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  color: ${theme.colors.neutralW10};
  padding: 0px 32px 24px;
  gap: 4px;

  @media ${device.mobile} {
    padding: 0px 24px 16px;
    gap: 0px;
  }
`;

export const BulkSelectionWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
};

export const SingleSelectionWrapperStyles = {
  display: 'flex',
  justifyContent: 'center',
  cursor: 'pointer',
};

export const TableFlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const TableMessagesWrapper = styled.div`
  flex: 0 0 auto;
`;

export const TableContainer = styled.div`
  flex: 1 1 auto;
  height: 540px;
`;

export const IconWrapper = styled.div`
  display: flex;
`;
